import type { Midia } from '@/shared/models/midia.model';
import type { Tela } from '@/shared/models/tela.model';

const HOSTS_YOUTUBE = new Set([
  'www.youtube.com',
  'youtube.com',
  'youtu.be',
  'www.youtube-nocookie.com',
]);

function mesmoUuid(a: unknown, b: string): boolean {
  return typeof a === 'string' && a.toLowerCase() === b.toLowerCase();
}

/** db_change de `telas`: só vale o registro da própria tela da URL. */
export function telaDoPayload(valor: unknown, telaId: string): valor is Tela {
  return !!valor && typeof valor === 'object' && mesmoUuid((valor as { id?: unknown }).id, telaId);
}

/** Registro (mídia, pedido da fila) com `tela_id` igual ao da tela da URL. */
export function registroDaTela(valor: unknown, telaId: string): boolean {
  return !!valor && typeof valor === 'object' && mesmoUuid((valor as { tela_id?: unknown }).tela_id, telaId);
}

export function urlMidiaPermitida(url: unknown, supabaseUrl: string): boolean {
  if (typeof url !== 'string') return false;

  let urlMidia: URL;
  try {
    urlMidia = new URL(url);
  } catch {
    return false;
  }

  if (urlMidia.protocol !== 'https:') return false;
  if (HOSTS_YOUTUBE.has(urlMidia.hostname)) return true;

  const urlSupabase = new URL(supabaseUrl);
  return urlMidia.hostname === urlSupabase.hostname
    && urlMidia.pathname.startsWith('/storage/v1/object/public/');
}

export function midiaValida(valor: unknown, supabaseUrl: string): valor is Midia {
  if (!valor || typeof valor !== 'object') return false;

  const midia = valor as { id?: unknown; url?: unknown };
  return typeof midia.id === 'string' && urlMidiaPermitida(midia.url, supabaseUrl);
}

export function momentoEspecialVideoValido(
  videoUrl: unknown,
  supabaseUrl: string,
): string | undefined {
  return urlMidiaPermitida(videoUrl, supabaseUrl) ? videoUrl as string : undefined;
}

